"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const associatedComponents_1 = require("@/store/ducks/associatedComponents");
const products_1 = require("@/store/ducks/products");
const index_view_1 = __importDefault(require("./index.view"));
function EditProduct() {
    const history = (0, react_router_dom_1.useHistory)();
    const dispatch = (0, react_redux_1.useDispatch)();
    react_1.default.useEffect(() => {
        history.listen(() => {
            dispatch((0, associatedComponents_1.resetAssociatedComponentsList)());
            dispatch((0, products_1.resetProductNameToBeAssociated)(null));
        });
    }, []);
    return react_1.default.createElement(index_view_1.default, null);
}
exports.default = EditProduct;
